import numeral from 'numeral';

export function fPercent(number: number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number: number) {
  return numeral(number).format();
}

export function fShortenNumber(number: number) {
  return numeral(number).format('0.0a').replace('.00', '');
}

export function fData(number: number) {
  return numeral(number).format('0.0 b');
}

export function fNumberRoundUp(number: number, precision = 0) {
  precision = precision == 0 ? 1 : Math.pow(10, precision);
  return Math.round(number * precision) / precision;
}

export function toFiniteNumber(v: unknown): number | null {
  // 숫자는 그대로, 문자열은 공백 제거 후 Number() 변환
  const n =
    typeof v === 'number' ? v : typeof v === 'string' ? Number(v.trim()) : NaN;

  return Number.isFinite(n) ? n : null; // NaN/Infinity/-Infinity → 제거
}
